import Error from "components/Generic/ErrorPage";

function NotFoundPage() {
  return <Error errorCode="404" />;
}

export default NotFoundPage;
